import React from 'react'

export function LoadableLoading (props) {
  if (props.error) {
    return <div className='v100h'>
      <div className="startup">
        <h3>Error! <button onClick={props.retry}>Retry</button></h3>
        <img className="loading-animation-large" src="/content/images/LogoSymbol.png" />
      </div>
    </div>
  } else {
    return <div className='v100h'>
      <div className="startup">
        <img className="loading-animation-large" src="/content/images/LogoSymbol.png" />
      </div>
    </div>
  }
}
